/**
 * Normalização de telefone — FONTE ÚNICA DE VERDADE.
 *
 * Espelha byte a byte a função SQL `normalizar_telefone(TEXT)` criada na
 * migration 003. Qualquer alteração aqui exige a mesma alteração lá.
 *
 * Formato canônico: E.164 sem o '+' → 5512991234567 (13 dígitos).
 *
 * Corrige os defeitos #10 e #11 da documentação: hoje o sistema convive com
 * três formatos ('(12) 99123-4567', '12991234567', '5512991234567') e as telas
 * concatenam '55' cegamente, gerando '555512991234567'.
 */
/** Remove tudo que não for dígito. */
export function apenasDigitos(valor) {
    return valor.replace(/\D/g, '');
}
/**
 * Converte qualquer formato conhecido para E.164 sem '+'.
 * Retorna `null` para entrada vazia/nula.
 *
 * NOTA DE NEGÓCIO: números com 10 dígitos (DDD + 8) recebem o nono dígito,
 * conforme especificado na migration 003 da documentação. Isso assume que todo
 * telefone cadastrado é celular. Telefones fixos legítimos serão convertidos
 * em números inválidos — revisar `_migracao_datas_falhas`/relatórios após o
 * backfill se a base tiver fixos.
 */
export function normalizarTelefone(tel) {
    if (tel == null)
        return null;
    const d = apenasDigitos(tel);
    if (d.length === 0)
        return null;
    if (d.length === 11)
        return `55${d}`;
    if (d.length === 10)
        return `55${d.slice(0, 2)}9${d.slice(2)}`;
    if (d.length === 13 && d.startsWith('55'))
        return d;
    if (d.length === 12 && d.startsWith('55'))
        return `55${d.slice(2, 4)}9${d.slice(4)}`;
    return d;
}
/** `true` quando o valor já está (ou pode ser levado) ao formato canônico de 13 dígitos. */
export function ehTelefoneValido(tel) {
    const e164 = normalizarTelefone(tel);
    return e164 !== null && e164.length === 13 && e164.startsWith('55');
}
/**
 * Exibição brasileira a partir de qualquer formato: (12) 99123-4567.
 * Usado no frontend; nunca use o resultado para enviar mensagem.
 */
export function formatarTelefoneBR(tel) {
    const e164 = normalizarTelefone(tel);
    if (!e164)
        return '';
    const local = e164.startsWith('55') && e164.length >= 12 ? e164.slice(2) : e164;
    if (local.length === 11)
        return `(${local.slice(0, 2)}) ${local.slice(2, 7)}-${local.slice(7)}`;
    if (local.length === 10)
        return `(${local.slice(0, 2)}) ${local.slice(2, 6)}-${local.slice(6)}`;
    return tel ?? '';
}
/**
 * Máscara progressiva para input controlado: aplica (##) #####-#### enquanto
 * o usuário digita, limitando a 11 dígitos. Preserva o comportamento de
 * `handlePhoneInput` do `os.html` atual.
 */
export function aplicarMascaraTelefone(valor) {
    const d = apenasDigitos(valor).slice(0, 11);
    if (d.length === 0)
        return '';
    if (d.length <= 2)
        return `(${d}`;
    if (d.length <= 7)
        return `(${d.slice(0, 2)}) ${d.slice(2)}`;
    return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}
//# sourceMappingURL=phone.js.map